export const keyCodes = {
  tab: 9,
  escape: 27,
  enter: 13,
  up: 38,
  down: 40,
  space: 32
};
